import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-login" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label mt-4"
}, "Email address", -1)
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "form-label mt-4"
}, "Password", -1)
const _hoisted_6 = { class: "d-grid gap-2 pt-5" }
const _hoisted_7 = { class: "invalid-feedback" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loginSubmit && _ctx.loginSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _withDirectives(_createElementVNode("input", {
            type: "email",
            class: "form-control",
            id: "email",
            name: "email",
            "aria-describedby": "emailHelp",
            placeholder: "Enter email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event))
          }, null, 512), [
            [_vModelText, _ctx.form.email]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "password",
            name: "password",
            class: "form-control",
            id: "password",
            placeholder: "Password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event))
          }, null, 512), [
            [_vModelText, _ctx.form.password]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn btn-lg btn-primary", { 'is-invalid': _ctx.form.errorMessage != '' }]),
            type: "submit"
          }, " Login ", 2),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.form.errorMessage), 1)
        ])
      ])
    ], 32)
  ]))
}